import Log from '@/Logger';

const IsDebugging = import.meta.env.DEBUG === 'true' || import.meta.env.DEBUG === '1';
export class S3ClientError extends Error {
    public original?: unknown;
    public status?: number;
    constructor(message: string, original?: unknown, status?: number) {
        super(message);
        this.name = 'S3ClientError';
        this.status = status;
        this.original = original;
        if (IsDebugging) // デバッグ中のみログを出す
            try {
                Log.getLogger().api.error('s3Client', `[${status ?? '-'}] ${message}`, original);
            } catch (e) {
                // Fallback to console when Logger not initialized
                // eslint-disable-next-line no-console
                console.error('[s3Client]', message, original);
            }
    }
}
